import React from 'react';
import C from '../colors';
import { formatMoney } from '../money';
import { paymentStatusMeta } from '../orderStatus';

function formatPaymentTime(value) {
  if (!value) return '尚未支付';
  const time = new Date(value);
  if (Number.isNaN(time.getTime())) return '—';
  return time.toLocaleString('zh-CN', { hour12: false });
}

const PAYMENT_TONE_STYLES = {
  brand: { background: C.brandSoft, color: C.brand2 },
  success: { background: C.successBg, color: C.successFg },
  warm: { background: C.warningBg, color: C.warningFg },
  danger: { background: C.dangerBg, color: C.dangerFg },
  neutral: { background: C.neutralBg, color: C.neutralFg },
};

function getSelectionPaymentMeta(selection, isOnlinePayment) {
  if (isOnlinePayment === false || Number(selection?.totalPrice || 0) <= 0) {
    return paymentStatusMeta({ paymentStatus: 'none' });
  }
  if (selection?.isPaid || selection?.paymentStatus === 'paid') {
    return paymentStatusMeta({ paymentStatus: 'paid' });
  }
  if (selection?.paymentStatus === 'requested') {
    return paymentStatusMeta({ paymentStatus: 'requested' });
  }
  if (selection?.paymentStatus === 'refunded') {
    return paymentStatusMeta({ paymentStatus: 'refunded' });
  }
  if (selection?.paymentStatus === 'failed') {
    return paymentStatusMeta({ paymentStatus: 'failed' });
  }
  return paymentStatusMeta({ paymentStatus: 'unpaid' });
}

export default function SelectionPaymentDetails({ selection, isOnlinePayment = true }) {
  if (!selection) return null;
  const paymentRequired = isOnlinePayment !== false && Number(selection.totalPrice || 0) > 0;
  const meta = getSelectionPaymentMeta(selection, isOnlinePayment);
  const tone = PAYMENT_TONE_STYLES[meta.tone] || PAYMENT_TONE_STYLES.neutral;
  const references = [
    ['商户订单号', selection.wxOutTradeNo || '未生成'],
    ['微信交易号', selection.wxTransactionId || '未生成'],
  ];

  return (
    <div data-testid="selection-payment-details" style={{
      marginTop: 10, padding: '11px 13px', borderRadius: 10,
      background: C.paper2, border: `1px solid ${C.hair}`,
      display: 'flex', alignItems: 'center', gap: '9px 18px', flexWrap: 'wrap',
      maxWidth: 860,
    }}>
      <span data-testid="selection-payment-status" style={{
        display: 'inline-flex', alignItems: 'center', padding: '4px 9px', borderRadius: 12,
        background: tone.background, color: tone.color,
        fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap',
      }}>
        {meta.label}
      </span>
      <span style={{ fontSize: 12, color: C.ink2, whiteSpace: 'nowrap' }}>
        <span style={{ color: C.ink3 }}>应付金额 </span>
        <strong data-testid="selection-payment-amount" style={{ color: C.ink, fontWeight: 650, fontVariantNumeric: 'tabular-nums' }}>
          ¥{formatMoney(selection.totalPrice, { minimumFractionDigits: 2 })}
        </strong>
      </span>
      {paymentRequired && <span style={{ fontSize: 12, color: C.ink2, whiteSpace: 'nowrap' }}>
        <span style={{ color: C.ink3 }}>支付时间 </span>
        <span data-testid="selection-payment-time" style={{ fontVariantNumeric: 'tabular-nums' }}>{formatPaymentTime(selection.paidTime)}</span>
      </span>}
      {paymentRequired && references.map(([label, value]) => (
        <span key={label} style={{ minWidth: 0, fontSize: 11, color: C.ink3 }}>
          {label}{' '}
          <code data-testid={label === '商户订单号' ? 'selection-payment-merchant-reference' : 'selection-payment-wechat-reference'} title={value} style={{
            color: value === '未生成' ? C.ink3 : C.ink2,
            fontFamily: C.mono, fontSize: 10.5, overflowWrap: 'anywhere', userSelect: 'text',
          }}>
            {value}
          </code>
        </span>
      ))}
    </div>
  );
}
